import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HTTP_INTERCEPTORS
} from '@angular/common/http';

import { DownloadIndicatorService } from './download-indicator.service';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators'
@Injectable()
export class DownloadIndicatorInterceptor implements HttpInterceptor {
  // dont open the dialog multiple times for multiple backend calls
  private count = 0;
  constructor(private diService: DownloadIndicatorService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.count === 0) {
      if(!req.url.endsWith("refresh")&&!req.url.includes('translation'))
      this.diService.openDialog()
    }
    this.count++;
    return next.handle(req).pipe(
      finalize(() => {
        this.count--;
        if (this.count === 0) {
          this.diService.closeDialog();
        }
      }));
  }

}

export const downloadIndicatorInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: DownloadIndicatorInterceptor, multi: true }
];

